import type React from 'react';
import { type PropsWithChildren, PureComponent, type ReactNode } from 'react';

import { findAncestorId } from '../search_items/utils';

type Props = PropsWithChildren<{
  items: string[];
  onExpand: (list: string[], id: string, value: boolean) => void;
}>;

class CollapsibleItems extends PureComponent<Props> {
  handleOnClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    const target = event.nativeEvent.target as HTMLElement;
    const id = findAncestorId(target);
    if (id && id === target.getAttribute('data-expand-target')) {
      this.expand(id);
    }
  };

  expand = (id: string | null): void => {
    if (id) {
      const { items } = this.props;
      const index = items.indexOf(id);
      const value = index < 0;
      if (value) {
        this.props.onExpand([...items, id], id, value);
      } else {
        const list = [...items];
        list.splice(index, 1);
        this.props.onExpand(list, id, value);
      }
    }
  };

  render(): ReactNode {
    return <div onClick={this.handleOnClick}>{this.props.children}</div>;
  }
}

export default CollapsibleItems;
